
import React, { useEffect, useState } from "react";
import SAA_JSON from "./FeatureCourse/ModifiedSI.json";
import "./stressAndIntonation.scss";
import { CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTemplateTitle } from "../../../redux/actions/soundsOfEnglishActions";
import ProductivityToolsDescriptionContainer from "../../shared/ProductivityToolsDescriptionContainer/ProductivityToolsDescriptionContainer";
import Loader from "../../shared/Loader/Loader";
import { getCapitalized, getTypeDescription, formatCategoryFormat } from "./utils/utils";
import { Course, Category } from "./utils/types";


const StressAndIntonation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [course, setCourse] = useState<Course[]>([]);

  useEffect(() => {
    if (SAA_JSON && Object.keys(SAA_JSON).length > 0) {
      const reducedDetails: { [key: string]: Course } = {}; // Change the type to an object with string keys
      SAA_JSON.forEach((details: Course) => {
        const capitalized = getCapitalized(details.Name);
        details.Description = getTypeDescription(details.Name);
        details.Name = capitalized;
        reducedDetails[capitalized] = details;
      });
      setCourse(Object.values(reducedDetails)); // Convert the object to an array before setting the state
      setShowLoader(false);
    }
  }, []);

  return (
    <>
      {showLoader && <Loader showLoader={showLoader} />}
      <div className="stress-intonation-wrapper">
        <div className="stress-intonation-container">
          <ProductivityToolsDescriptionContainer
            headingTitle="stress_intonation_product_headline"
            featureDescription="stress_intonation_product_description"
            featureImg={window.location.origin + "/images/" + "Feature_Illustrations/Stress-and-intonation.svg"}
          />
          <div className="course-details-list-wrapper">
            {Object.keys(course).length === 0 ? (
              <div className="loader-container">
                <CircularProgress className="stress-and-intonation-loader" />
                <p className="loading-label">Loading</p>
              </div>
            ) : (
              Object.keys(course).map((courseKey: string ) => {
                const currentCourse = course[Number(courseKey)];
                return (
                  <div className="each-course-box" key={currentCourse.Id}>
                    <p className="each-course-title">{currentCourse.Name}</p>
                    <p className="each-course-description">{currentCourse.Description}</p>
                    <div className="horizontal-bar"></div>
                    <div className="each-course-categories">
                      {currentCourse.Categories?.map((category: Category) => {
                          const navigatePath = `/stressandintonation/${currentCourse.Id}/${category.CategoryObjectId}/${category.Items[0].link}/${category.Items[0].ActivityId}`;
                          const templateTitle = `${currentCourse.Name + ":" + " " + category.CategoryName}`;
                          return (
                            <button
                              className="each-category-box"
                              key={category.CategoryObjectId}
                              onClick={() => {
                                navigate(navigatePath, { state:{submenu:category.Items[0]}  });
                                dispatch(setTemplateTitle(templateTitle));
                              }}
                            >
                              <p className="each-category-title">{formatCategoryFormat(category.CategoryName)}</p>
                            </button>
                          );
                        })}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default StressAndIntonation;
